import {createAction, props} from '@ngrx/store';
import {ProleisObject} from '@proleis/proleis-rest-client';
import {OrdersOverview} from './orders.state';
import {Observable} from 'rxjs';

export const LOAD_OVERVIEW = createAction(
  '[Orders] load orders-overview',
  props<{ orderId: string, overviewType: string }>()
);

export const LOAD_OVERVIEW_SUCCESS = createAction(
  '[Orders] orders orders-overview loaded',
  props<{ overview: OrdersOverview }>()
);

export const LOAD_OVERVIEW_ERROR = createAction(
  '[Orders] error while loading order orders-overview'
);

export const FILTER_OVERVIEW = createAction(
  '[Orders] filter orders-overview',
  props<{ filter: string, overview$: Observable<OrdersOverview> }>()
);

export const FILTER_OVERVIEW_SUCCESS = createAction(
  '[Orders] orders filtered',
  props<{ filteredOverview: OrdersOverview }>()
);

export const LOAD_ORDER = createAction(
  '[Orders] load order',
  props<{ orderId: string }>()
);

export const LOAD_ORDER_SUCCESS = createAction(
  '[Order] order loaded',
  props<{ order: ProleisObject }>()
);

export const LOAD_ORDER_ERROR = createAction(
  '[Order] error while loading order'
);

export const LOAD_ORDERS = createAction(
  '[Orders] load orders',
  props<{
    filterStart: Date,
    filterEnd: Date,
    filterAll: boolean,
    filterChanged: boolean,
    filterChannel: string | undefined
  }>()
);

export const LOAD_ORDERS_SUCCESS = createAction(
  '[Orders] orders loaded',
  props<{ orders: ProleisObject[] }>()
);

export const LOAD_ORDERS_ERROR = createAction(
  '[Orders] error while loading orders'
);

export const LOAD_CHANNELS = createAction(
  '[Orders] load channels'
);

export const LOAD_CHANNELS_SUCCESS = createAction(
  '[Orders] channels loaded',
  props<{ channels: ProleisObject[] }>()
);

export const LOAD_CHANNELS_ERROR = createAction(
  '[Orders] error while loading channels'
);

export const SELECT_TAB_INDEX = createAction(
  '[Orders] selected tab changed',
  props<{ index: number }>()
);
